module.exports = __webpack_public_path__ + "static/img/20@2x.5fc62dbd.png";